import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

//components
import { FaFolderOpen } from "react-icons/fa";
import { Spinner, Row } from "react-bootstrap";
import { ListContent } from "../favorites-list/styles"

//services
import { listFavoriteObjects } from "../../../../services/favorites.service"
import { CardList } from "../../../../components/card-list";
import { IListFavorites } from "../models/IListFavorites";
import { getStorageFavoriteMaterials } from "../../../../utils/storageFavoriteMaterials";


export const ObjectFavorites: React.FC<IListFavorites> = ({ removeFavorite, listFilter, isAuth }) => {
  const { t: translation } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [objects, setObjects] = useState([]);

  useEffect(() => {
    if (isAuth) {
      listFavoriteObjects(listFilter).then((resp: any) => {
        setObjects(resp.results);
      }).finally(() => {
        setLoading(false);
      })
    } else {
      const favoriteMaterials = getStorageFavoriteMaterials('@favorites_medias')
      if (favoriteMaterials) {
        listFilter.favorites = favoriteMaterials
      }
      listFavoriteObjects(listFilter).then((resp: any) => {
        setObjects(resp.results);
      }).finally(() => {
        setLoading(false);
      })
    }

  }, [listFilter])

  if (loading) {
    return (
      <div className="loading-container mt-5">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  return (
    <Row>
      <ListContent>
        {
          objects.length === 0 ? (
            <div className="text-center text-grey mt-5">
              <FaFolderOpen className="mt-5" size={150} />
              <h5>{translation("favorites.emptyObjects")}</h5>
            </div>
          ) :
            (
              objects.map((object: any) => (
                <CardList key={object.favorite_id} material={object} isMaterialView={true} removeFavorite={removeFavorite} />
              ))
            )
        }
      </ListContent>
    </Row>
  )
}